import React, { FC } from 'react'
import { ComponentContentRows } from '../../../models/components/contentRows'
import { ContentRowsContainer } from './style'
import { RenderRowContainers } from './subcomponents/rowContainers'

type Props = {
  data: ComponentContentRows
  isRichText?: boolean
}

const ContentRows: FC<Props> = ({ data, isRichText = false }) => {
  const content = {
    topPadding: data.topPadding || 'None',
    bottomPadding: data.bottomPadding || 'None',
    background: data.theme || 'Light',
    useCase: data.useCase || '',
    rows: data.rows || [],
    title: data.title || '',
  }

  const isAgenda = content.useCase === 'Agenda'

  return (
    <ContentRowsContainer
      $topPadding={content.topPadding}
      $bottomPadding={content.bottomPadding}
      $backgroundTheme={content.background}
      $useCase={content.useCase}
      data-cy={isAgenda ? 'contentRows--Agenda' : 'contentRows--Accordion'}>
      <RenderRowContainers content={content} isAgenda={isAgenda} isRichText={isRichText} />
    </ContentRowsContainer>
  )
}

export default ContentRows
